import { render } from "./CuisinesSectionView.vue?vue&type=template&id=4fffdf95&scoped=true"
import script from "./CuisinesSectionView.vue?vue&type=script&lang=js"
export * from "./CuisinesSectionView.vue?vue&type=script&lang=js"

import "./CuisinesSectionView.vue?vue&type=style&index=0&id=4fffdf95&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fffdf95"]])

export default __exports__